import classNames from 'classnames';
import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import { useWindowHeight } from '../../helpers/hooks';
import ModalHeader from './ModalHeader';

export type ModalProps = ReactModal.Props & {
  className?: ReactModal.Classes;
  contentStyle?: { [key: string]: any };
  showOverlayBackgroundColor?: boolean;
  overlayStyle?: { [key: string]: any };
  children?: ReactNode;
  id?: string;
};

const Modal = ({
  children = null,
  className = {
    base: '',
    beforeClose: '',
    afterOpen: ''
  },
  contentStyle = {},
  overlayClassName = '',
  showOverlayBackgroundColor = true,
  overlayStyle = {},
  ...restProps
}: ModalProps) => {
  const windowHeight = useWindowHeight();
  return (
    <ReactModal
      style={{
        overlay: {
          ...ReactModal.defaultStyles.overlay,
          backgroundColor: showOverlayBackgroundColor
            ? 'rgba(27, 27, 27, 0.75)'
            : 'transparent',
          zIndex: 100,
          ...overlayStyle,
          bottom: 'auto',
          height: `${windowHeight}px`
        },
        content: contentStyle
      }}
      overlayClassName={classNames('flex', overlayClassName)}
      className={{
        base: classNames('bg-white relative', className.base),
        afterOpen: classNames('', className.afterOpen),
        beforeClose: classNames('', className.beforeClose)
      }}
      {...restProps}
    >
      {children}
    </ReactModal>
  );
};

Modal.Header = ModalHeader;

export default Modal;
